import HeaderHome from "../components/HeaderHome";
import SiteFooter from "../components/SiteFooter";
import { WHATSAPP_URL } from "../constants";

export default function LegalPage() {
  return (
    <div className="site-root">
      <HeaderHome />

      <main className="page-main">
        <div className="container prose">

          <h1>Terms & Conditions</h1>

          <p className="updated">
            Last updated: 12 April 2026. Please read carefully before placing an order.
          </p>

          <p>
            These Terms & Conditions ("Terms") govern your use of FreshClayPot services,
            including orders placed via website or WhatsApp. By placing an order, you
            agree to these Terms.
          </p>

          {/* PRODUCT NATURE */}
          <h2>1. Nature of the Product</h2>
          <p>
            Our curd is a freshly prepared, perishable dairy product made using traditional
            methods in clay pots. It is not intended for long shelf storage.
          </p>

          <p>
            Natural variations in texture, thickness, taste, and appearance may occur
            between batches and should not be considered defects.
          </p>

          {/* SMALL SCALE DISCLAIMER */}
          <h2>2. Small-Scale Production Disclaimer</h2>
          <p>
            FreshClayPot operates as a small-scale, home-style food preparation service.
            Products are prepared in limited batches using traditional methods and are
            intended for immediate consumption.
          </p>

          {/* ORDERS */}
          <h2>3. Orders, Pricing & Payment</h2>
          <p>
            Prices, availability, and delivery schedules may change without prior notice.
            Orders are confirmed only after communication via WhatsApp or direct confirmation.
          </p>

          {/* DELIVERY */}
          <h2>4. Delivery & Responsibility</h2>
          <p>
            Responsibility for the product transfers to the customer at the time of delivery.
            Customers must refrigerate immediately upon receiving the product.
          </p>

          <p>
            We are not responsible for spoilage due to delayed collection, improper storage,
            or exposure to unsuitable temperatures after delivery.
          </p>

          {/* FOOD SAFETY */}
          <h2>5. Storage & Food Safety</h2>
          <ul>
            <li>Refrigerate immediately after receiving</li>
            <li>Consume within a reasonable time (same day or next day recommended)</li>
            <li>Do not consume if smell or appearance seems abnormal</li>
          </ul>

          <p>
            FreshClayPot is not responsible for any issues arising from delayed consumption,
            including consumption after extended periods (e.g., 2–3 days), or improper storage.
          </p>


          <p>
            Clay pots are fragile and may have minor imperfections due to handmade nature.
          </p>

          {/* ALLERGEN */}
          <h2>6. Allergen Information</h2>
          <p>
            This product contains milk (dairy). It is not suitable for individuals with
            milk allergies or lactose intolerance unless verified by a medical professional.
          </p>

          {/* RETURNS */}
          <h2>7. Returns & Refunds</h2>
          <p>
            Due to the perishable nature of the product, returns are generally not accepted.
          </p>

          <p>
            If there is a genuine issue at the time of delivery, customers must contact us
            immediately via WhatsApp with details. Resolution will be handled on a case-by-case basis.
          </p>

          {/* LIABILITY */}
          <h2>8. Limitation of Liability</h2>
          <p>
            FreshClayPot shall not be liable for any indirect or consequential damages
            arising from the use or consumption of the product.
          </p>
          <p>
            This includes, but is not limited to, issues resulting from delayed consumption,
            improper storage, failure to refrigerate, or consumption beyond the recommended timeframe.
          </p>

          <p>
            Our total liability is limited to the amount paid for the specific order.
          </p>

          {/* WEBSITE */}
          <h2>9. Website Information</h2>
          <p>
            Information on this website is provided for general guidance. Product images
            are for illustration purposes only and actual appearance may vary.
          </p>

          {/* IP */}
          <h2>10. Intellectual Property</h2>
          <p>
            All content including text, images, and branding belongs to FreshClayPot and
            may not be reused without permission.
          </p>

          {/* LAW */}
          <h2>11. Governing Law</h2>
          <p>
            These Terms are governed by the laws of India.
          </p>

          {/* CONTACT */}
          <h2>12. Contact</h2>
          <p>
            For any queries or complaints, contact us on WhatsApp:
          </p>

          <p>
            👉{" "}
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
              +91 8688307782
            </a>
          </p>

        </div>
      </main>

      <SiteFooter secondaryTo="/" secondaryLabel="Home" />
    </div>
  );
}